// eslint-disable-next-line
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import AppContext from '../context/Context';
import { getPageName } from '../helpers/utils'; // eslint-disable-next-line
import { toast } from 'react-toastify'; // eslint-disable-next-line
import Voting from '../components/voting';
const VotingRoutes = ({ location }) => {
	// eslint-disable-next-line
	const { isFluid, isVertical, navbarStyle } = useContext(AppContext); // eslint-disable-next-line
	const isKanban = getPageName('kanban');
	useEffect(() => {
		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	return (
		<div className={''}>
			<div className='content contentMain'>
				<Switch>
					<Route path='/live/voting/:id' exact component={Voting} />
					{/*Redirect*/}
					<Redirect to='/' />
				</Switch>
			</div>
		</div>
	);
};

VotingRoutes.propTypes = { location: PropTypes.object.isRequired };

export default VotingRoutes;
